import { loginUrl } from './util';
import request from '@/utils/request';
import type { ProductModule, IProductItem } from '@/components/MembersDay/type';
import { CookieDataExtendType } from 'eco-design-reliance/cookies/type.d';
import { subscribeCookie } from 'eco-design-reliance/cookies/subscribeCookie';

export type ResponseObj<T = unknown> = {
    code: string;
    data: T;
    message: string;
};

/**
 * 查询秒杀产品列表
 */
export const getListSecKillProducts = (
    locale: string,
): Promise<
    ResponseObj<{
        productList: IProductItem[];
        secKillStartTime: string;
        secKillEndTime: string;
    }>
> => request.post(`${loginUrl(locale)}/shopify/web/creditsYear/listSecKillProducts`, { data: {}, needToken: true });

/**
 * 查询普通产品列表
 * (HOT-热门模块;NORMAL-常规模块;ECOLOGY-生态产品)
 */
export const getListProducts = (params: { module: ProductModule }, locale: string): Promise<ResponseObj<IProductItem[]>> =>
    request.post(`${loginUrl(locale)}/shopify/web/creditsYear/listProducts`, { data: params, needToken: true });

/**
 * 获取产品购买url
 */
export const getProductUrl = (id: string, locale: string) =>
    request.post(`${loginUrl(locale)}/shopify/web/creditsYear/getSecKillProductUrl`, { data: { id }, needToken: true });

/**
 * 提交TradeIn表单
 */
export const createTradeIn = (
    data: {
        brand: string;
        countryCode: string;
        email: string;
        firstName: string;
        lastName?: string;
        pictureUrl: string;
        recaptchaResponse: string;
        sn: string;
        upgrade: string;
    },
    locale: string,
): Promise<ResponseObj<any>> =>
    request.post(`${loginUrl(locale)}/website/creditsDay/createTradeIn`, {
        data,
        needToken: true,
    });

/**
 * 邮箱订阅
 */
export const subscribe = (email: string, locale: string, source: string, subscribeData?: CookieDataExtendType): Promise<ResponseObj<any>> =>
    request.post(`${loginUrl(locale)}/website/subscribe`, {
        data: subscribeData
            ? {
                  email,
                  source,
                  eventTracking: subscribeCookie(subscribeData),
              }
            : {
                  email,
                  source,
              },
        needToken: true,
    });

/**
 * 邮箱订阅2
 */
export const subscribeShopify = (
    data: {
        contactListId: string;
        email: string;
        fields: [
            {
                id: string;
                overwrite: boolean;
                type: string;
                value: string[];
            },
        ];
        phone?: string;
        smsContactListId: string;
    },
    locale: string,
    subscribeData?: CookieDataExtendType,
): Promise<ResponseObj<any>> => {
    const obj = {
        sector_name: 'Banner',
        entry_position: 1,
    } as CookieDataExtendType;

    if (subscribeData) {
        (Object.keys(subscribeData) as Array<keyof CookieDataExtendType>)?.map((k: keyof CookieDataExtendType) => {
            if (k && subscribeData[k]) {
                obj[k] = subscribeData[k];
            }
        });
    }
    return request.post(`${loginUrl(locale)}/website/subscribe/shopify`, {
        data: subscribeData ? { ...data, eventTracking: subscribeCookie(obj) } : data,
        needToken: true,
    });
};
/**
 * 邮箱订阅-发起一个请求
 */
export const sendSubscribeGet = (email: string) => {
    const email2 = `${email}`;
    const url = `https://media.ecoflow.com/u/register.php?CID=1049983726&f=1237&p=2&a=r&SID=&el=&llid=&counted=&c=&optin=y&inp_3=${email2.trim()}&inp_4423=1&inp_7715=19&inp_8520=3`;
    if (typeof window !== 'undefined') {
        const elem = document.createElement('img');
        elem.classList.add('temp-hide');
        elem.src = url;
        document.body.appendChild(elem);
    }
};

/**
 * 查询是否在黑名单
 */
export const checkBlacklist = (
    locale: string,
): Promise<
    ResponseObj<{
        inBlackList: boolean;
    }>
> =>
    request.get(`${loginUrl(locale)}/integral/web/riskBlacklistInfo/getBlacklist`, {
        needToken: true,
    });

/**
 * 邮箱订阅new
 */
export const subscribeMultiEmarsysEmail = async (locale: string, data: any, subscribeData?: CookieDataExtendType) => {
    const obj = {
        sector_name: 'Banner',
        entry_position: 1,
    } as CookieDataExtendType;

    if (subscribeData) {
        (Object.keys(subscribeData) as Array<keyof CookieDataExtendType>)?.map((k: keyof CookieDataExtendType) => {
            if (k && subscribeData[k]) {
                obj[k] = subscribeData[k];
            }
        });
    }
    return request.post(`${loginUrl(locale)}/website/subscribe/new`, {
        data: subscribeData ? { ...data, eventTracking: subscribeCookie(obj) } : data,
        headers: {
            // apiKey: '527760f6df93c0d6e98609fa8e8a1f4a',
        },
    });
};
